import React, { useState } from 'react';
import { useProject } from '../../contexts/ProjectContext';
import ActivityTable from '../../components/scheduling/ActivityTable';

const ActivityTablePreviewPage = () => {
  const { activeProject, activeSchedule } = useProject();
  const [selectedActivityId, setSelectedActivityId] = useState(null);

  if (!activeProject || !activeSchedule) {
    return (
      <div className="p-6">
        <h1 className="text-lg font-semibold mb-2">ActivityTable Preview</h1>
        <p className="text-sm text-slate-600">
          Pick a project from the header first — this page renders the standalone
          <code className="mx-1 px-1 bg-slate-100 rounded">ActivityTable</code>
          component (not the unified view) so you can see the new columns in isolation.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-2 border-b border-slate-200 bg-amber-50 text-xs text-amber-900">
        Dev preview · standalone <code>ActivityTable</code> · project <strong>{activeProject.name}</strong> · schedule <strong>{activeSchedule.name}</strong>
      </div>
      <div className="flex-1 min-h-0">
        <ActivityTable
          selectedWbsId={null}
          selectedWbs={null}
          selectedActivityId={selectedActivityId}
          onSelectActivity={(act) => setSelectedActivityId(act?.id || null)}
          onActivityChange={() => {}}
        />
      </div>
    </div>
  );
};

export default ActivityTablePreviewPage;
